import { Component, Input } from '@angular/core';
import { SectionSummaryInterface } from '@vendasta/snapshot';
import { MatNavList } from '@angular/material/list';

import { UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GradeComponent } from '../../core';

@Component({
  selector: 'snap-section-grade',
  templateUrl: './section-grade.component.html',
  styleUrls: ['./section-grade.component.scss'],
  imports: [MatNavList, GradeComponent, UpperCasePipe, TranslateModule],
})
export class SectionGradeComponent {
  @Input() section: SectionSummaryInterface;
  @Input() showGrade: boolean;
}
